import { useAuth } from "@/hooks/use-auth";

/**
 * Shown when the user has a valid Cognito session but the API rejects every
 * request because their account has no `custom:tenant_id` set (or another
 * tenant-scoping failure). Reached either:
 *   - directly via api.ts handling a structured `403 {code: "no_tenant"}`, or
 *   - via api.ts loop-counter when 401s repeat within 30s.
 *
 * Static page — does NOT call any authenticated API. The only action is
 * sign-out (clears the local session + bounces through Cognito hosted-UI
 * logout so the next sign-in starts clean).
 */
export default function NoTenantPage() {
  const { logout } = useAuth();

  return (
    <div className="flex min-h-screen items-center justify-center bg-background p-4">
      <div className="max-w-md text-center">
        <h1 className="text-2xl font-semibold">No tenant assigned</h1>
        <p className="mt-3 text-sm text-muted-foreground">
          Your account is signed in but isn&apos;t linked to a tenant yet. An
          administrator needs to assign you to one before you can use the
          platform.
        </p>
        <p className="mt-2 text-sm text-muted-foreground">
          If you&apos;re an administrator and just set up federation, the
          assignment may not have been written to your Cognito profile. Sign
          out, sign back in, and try again.
        </p>
        <button
          type="button"
          onClick={logout}
          className="mt-6 inline-flex items-center justify-center rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground transition hover:bg-primary/90"
        >
          Sign out
        </button>
      </div>
    </div>
  );
}
